import type { Invitation } from '#/domain/invitation/Invitation'
import type { InvitationRepository } from '#/domain/invitation/InvitationRepository'

export class ResendInvitationUseCase {
  constructor(private readonly repository: InvitationRepository) {}

  async execute(invitation: Invitation): Promise<void> {
    return this.repository.resend(invitation)
  }
}
